import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';

import { BrandsPageComponent } from './brands-page/brands-page.component';
import { BrandPageComponent } from './brands-page/brand-page/brand-page.component';
import { BrandProgramPageComponent } from './brands-page/brand-page/brand-program-page/brand-program-page.component';
import { SharedModule } from '../shared/shared.module';
import { MatchingGiftPageComponent } from './brands-page/brand-page/matching-gift-page/matching-gift-page.component';
import { MatchingGiftDialogComponent } from './matching-gift-dialog/matching-gift-dialog.component';
import {
  NoKpiMatchingGiftPageComponent
} from './brands-page/brand-page/no-kpi-matching-gift-page/no-kpi-matching-gift-page.component';
import { NoKpiMatchingGiftDialogComponent } from './no-kpi-matching-gift-dialog/no-kpi-matching-gift-dialog.component';
import {
  MatchingGiftValidateDialogComponent
} from './matching-gift-validate-dialog/matching-gift-validate-dialog.component';
import {
  ResearchImpactBannerComponent
} from './brands-page/brand-page/research-impact-banner/research-impact-banner.component';
import { BrandPageGuard } from '../guards/brand-page.guard';
import { LacOnlyGuard } from '../guards/lac-only.guard';


const routes: Routes = [
  {path: '', component: BrandsPageComponent},
  {
    path: ':slug', children: [
      {path: '', component: BrandPageComponent, canActivate: [BrandPageGuard, LacOnlyGuard]},
      {
        path: 'matching-gift', children: [
          {path: ':program', component: MatchingGiftPageComponent, canActivate: [LacOnlyGuard]},
          {path: '**', component: BrandPageComponent, canActivate: [BrandPageGuard, LacOnlyGuard]}
        ]
      },
      {
        path: 'no-kpi-matching-gift', children: [
          {path: ':program', component: NoKpiMatchingGiftPageComponent, canActivate: [LacOnlyGuard]},
          {path: '**', component: BrandPageComponent, canActivate: [BrandPageGuard, LacOnlyGuard]}
        ]
      },
      {path: ':program', component: BrandProgramPageComponent},
      {path: '**', component: BrandPageComponent, canActivate: [BrandPageGuard, LacOnlyGuard]}
    ]
  }
];

@NgModule({
  declarations: [
    BrandsPageComponent, BrandPageComponent, BrandProgramPageComponent,
    MatchingGiftPageComponent,
    MatchingGiftDialogComponent,
    NoKpiMatchingGiftPageComponent,
    NoKpiMatchingGiftDialogComponent,
    MatchingGiftValidateDialogComponent,
    ResearchImpactBannerComponent
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    SharedModule
  ]
})
export class BrandsModule { }
